import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import EnrollmentListRow from './EnrollmentListRow';
import { EnrolledPeopleValue } from '../../../model/enrollment';

interface EnrollmentListDataProps {
    data?: EnrolledPeopleValue;
}

export default function EnrollmentListTable( { data }: EnrollmentListDataProps) {
    return (

            <Stack spacing={3}
                sx={{
                    paddingLeft: 2,
                    paddingRight: 2,
                    paddingTop: 2
                }}
                divider={<Divider orientation="horizontal" flexItem={true} />}>

                {data?.value.map(  val  => {

                    return <EnrollmentListRow key={val.id} data={val.metaData} />
                })}


            </Stack>

    )

}
